import { useCallback, useMemo } from 'react';
import { loadReCaptcha } from 'react-recaptcha-v3-updated';

const useRecaptcha = (disabled = false, recaptchaKey = '') => {
    const sitekey = recaptchaKey;
    const onLoadCallback = useCallback(() => {
        let component = document.getElementsByName('g-recaptcha-response');
        let textAreas = [...component];
        textAreas.map(textArea => {
            textArea.setAttribute('aria-hidden', 'true');
            textArea.setAttribute('aria-label', 'do not use');
            textArea.setAttribute('aria-readonly', 'true');
        });
    }, []);

    const loadPromise = useMemo(() => {
        if(!disabled) {
            return new Promise(resolve => {
                loadReCaptcha(sitekey, resolve);
            }).then(onLoadCallback);
        }
    }, [disabled]);

    const getRecaptchaToken = useCallback(action => {
        if(!disabled) {
            if (window.grecaptcha !== undefined) {
                return window.grecaptcha.execute(sitekey, { action });
            }
            else return loadPromise.then(() => {
                return window.grecaptcha.execute(sitekey, { action });
            }
            );
        }
    }, [disabled]);

    return useMemo(() => ({ getRecaptchaToken }), []);
};

export default useRecaptcha;